import script from "./MemberUpdatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberUpdatePage.vue?vue&type=script&setup=true&lang=js"

import "./MemberUpdatePage.vue?vue&type=style&index=0&id=188de8ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188de8ba"]])

export default __exports__